// ExhibitorsRelatedContainer.tsx
"use client"

import React, { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import ExhibitorsRelatedList from "./ExhibitorsRelatedList"

import ParticipationModal from "./ParticipationModal"
import {
  ExhibitionStandCategory,
  Participation,
} from "./types"

const ExhibitorsRelatedContainer: React.FC = () => {
  // Stand Category Modal State
 
  // Participation Modal State
  const [participationModalOpen, setParticipationModalOpen] = useState(false)
  const [selectedParticipation, setSelectedParticipation] = useState<Participation | null>(null)

  // Active Exhibitor ID (from the list component)
  const [selectedExhibitorId, setSelectedExhibitorId] = useState<number>(0)

  const [refreshTrigger, setRefreshTrigger] = useState(false)

 

  
  // Participation Handlers
  const handleOpenAddParticipation = () => {
    setSelectedParticipation(null)
    setParticipationModalOpen(true)
  }
  const handleOpenEditParticipation = (item: Participation) => {
    setSelectedParticipation(item)
    setParticipationModalOpen(true)
  }
  const handleParticipationSuccess = () => {
    setParticipationModalOpen(false)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Exhibitor Details" parent="Exhibitors" />
      <Container fluid>
        <Row>
          <Col md="12">
            <ExhibitorsRelatedList
              onAddParticipation={handleOpenAddParticipation}
              onEditParticipation={handleOpenEditParticipation}
              refreshTrigger={refreshTrigger}
              setExhibitorId={setSelectedExhibitorId}
            />
          </Col>
        </Row>

       {/* Participation Modal */}
        <ParticipationModal
          isOpen={participationModalOpen}
          toggle={() => setParticipationModalOpen(false)}
          onSuccess={handleParticipationSuccess}
          initialData={selectedParticipation}
          exhibitorId={selectedExhibitorId}
        />

        
      </Container>
    </>
  )
}

export default ExhibitorsRelatedContainer
